import { Box } from '@mui/material'
import { useContext } from 'react'

import { FilterValue } from 'components/Filter'
import { Form } from 'components/Form'
import { AmazonPageContext } from 'features/globalSetup/features/amazon/contexts/AmazonPageContext'
import { CONTAINER_SPACING } from 'providers/material-ui/theme/constants'
import { AdUnitAmazonsTable } from './components/AdUnitAmazonsTable'
import { DomainSection } from './components/DomainSection'
import { useGetDomainAmazons } from './hooks/useGetDomainAmazons'
import { useUpdateDomainAmazon } from './hooks/useUpdateDomainAmazon'
import { schema, Schema, schemaDefaults } from './schema'

type Props = {
  filters: FilterValue[]
}

export const InventoryConnectionForm = ({ filters }: Props) => {
  const { options } = useGetDomainAmazons()
  const { errors: apiErrors, update } = useUpdateDomainAmazon()
  const { formId, setTouched, setValid } = useContext(AmazonPageContext)

  return (
    <Form<Schema>
      externalErrors={apiErrors}
      id={formId}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefaults}
    >
      {() => (
        <>
          <DomainSection options={options} />

          <Box sx={{ pt: CONTAINER_SPACING }}>
            <AdUnitAmazonsTable filters={filters} />
          </Box>
        </>
      )}
    </Form>
  )
}
